export const defaultQuestions = {
  personality: [
    {
      title: '粘人',
      name: 'clingy',
    },
    {
      title: '膽小',
      name: 'timid',
    },
    {
      title: '親人',
      name: 'nice',
    },
    {
      title: '活潑',
      name: 'lively',
    },
    {
      title: '怕生',
      name: 'shy',
    },
    {
      title: '討厭同類',
      name: 'hate-same',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  healthy: [
    {
      title: '無，狀態良好',
      name: 'none',
      text: '',
    },
    {
      title: '心臟病',
      name: 'heart-disease',
      text: '',
    },
    {
      title: '氣喘',
      name: 'asthma',
      text: '',
    },
    {
      title: '氣管塌陷',
      name: 'tracheal-collapse',
      text: '',
    },
    {
      title: '白內障',
      name: 'cataract',
      text: '',
    },
    {
      title: '癲癇',
      name: 'epilepsy',
      text: '',
    },
    {
      title: '心絲蟲',
      name: 'heartworm',
      text: '',
    },
    {
      title: '艾利希體',
      name: 'ehrlichiosis',
      text: '',
    },
    {
      title: '腹膜炎',
      name: 'peritonitis',
      text: '',
    },
    {
      title: '腹積水',
      name: 'ascites',
      text: '',
    },
    {
      title: '手術外傷未癒合',
      name: 'surgery-wound-not-healed',
      text: '',
    },
    {
      title: '髖關節問題',
      name: 'hip-joint-problem',
      text: '',
    },
    {
      title: '骨折',
      name: 'fracture',
      text: '',
    },
    {
      title: '腸炎',
      name: 'enteritis',
      text: '',
    },
    {
      title: '血便',
      name: 'bloody-stool',
      text: '',
    },
    {
      title: '血尿',
      name: 'bloody-urine',
      text: '',
    },
    {
      title: '懷孕',
      name: 'pregnant',
      text: '',
    },
    {
      title: '傳染性疾病',
      name: 'infectious-disease',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  behavior: [
    { title: '分離焦慮症', name: 'SAD', text: '' },
    { title: '攻擊過家人', name: 'attack-familly', text: '' },
    { title: '攻擊陌生人', name: 'attack-stranger', text: '' },
    { title: '攻擊過同類', name: 'attack-same', text: '' },
    { title: '被同類咬過', name: 'be-attacked', text: '' },
  ],
  latestVaccineDate: '',
  // 美容產業
  pregnant: [{ title: '未懷孕', name: 'not-pregnant', text: '' }, { title: '備孕中', name: 'ttc', text: '' }, { title: '懷孕中', name: 'pregnant', text: '' }],
  // 生活狀況
  livinCondition: [
    { title: '抽菸', name: 'smokes', text: '' },
    { title: '喝酒', name: 'drink-wine', text: '' },
    { title: '熬夜', name: 'stay-up', text: '' },
    { title: '飲料、咖啡', name: 'coffee', text: '' },
    { title: '藥物', name: 'drug', text: '' },
  ],
  // 健康狀態
  healthStatus: [
    { title: '胃腸不佳', name: 'indigestion', text: '' },
    { title: '貧血', name: 'anemia', text: '' },
    { title: '便秘問題', name: 'constipation', text: '' },
    { title: '疲勞', name: 'fatigue', text: '' },
    { title: '肩頸僵硬', name: 'stiff-neck', text: '' },
    { title: '手腳冰冷', name: 'cold-extremities', text: '' },
    { title: 'B型肝炎', name: 'hepatitis-b', text: '' },
    { title: '高血壓', name: 'hypertension', text: '' },
    { title: '低血壓', name: 'hypotension', text: '' },
    { title: '更年期煩惱', name: 'menopause', text: '' },
    { title: '月經失調', name: 'menstrual-irregularity', text: '' },
    { title: '血友病', name: 'hemophilia', text: '' },
    { title: '甲狀腺失調', name: 'thyroid-dysfunction', text: '' },
    { title: '睡眠困擾', name: 'insomnia', text: '' },
    { title: '氣喘', name: 'asthma', text: '' },
    { title: '其他', name: 'other', text: '' },
  ],
  // 肌膚狀態
  skinCondition: [
    { title: '異位性皮膚炎', name: 'atopic-dermatitis', text: '' },
    { title: '脂漏性皮膚炎', name: 'seborrheic-dermatitis', text: '' },
    { title: '酒糟皮膚', name: 'rosacea', text: '' },
    { title: '濕疹', name: 'eczema', text: '' },
    { title: '蕁麻疹', name: 'urticaria', text: '' },
    { title: '水腫', name: 'edema', text: '' },
    { title: '乾癬', name: 'psoriasis', text: '' },
    { title: '過敏體質', name: 'allergic-constitution', text: '' },
    { title: '易色素沈澱膚質', name: 'hyperpigmentation', text: '' },
    { title: '特定成分過敏', name: 'specific-ingredient-allergy', text: '' },
    { title: '其他肌膚問題', name: 'other', text: '' },
  ],
  // 有無開刀史
  historyOfSurgery: [{ title: '有', name: 'yes', text: '' }, { title: '無', name: 'no', text: '' }],
  skinType: [
    { title: '油性', name: 'oily', text: '' },
    { title: '混合', name: 'combination', text: '' },
    { title: '乾性', name: 'dry', text: '' },
    { title: '中性', name: 'normal', text: '' },
    { title: '敏感問題', name: 'sensitive', text: '' },
  ], // 膚質
  sunProtectionStatus: [
    { title: '無', name: 'none', text: '' },
    { title: '每天', name: 'daily', text: '' },
    { title: '一週2-3次', name: '23-times-per-week', text: '' },
    { title: '出門才防曬', name: 'only-when-going-out', text: '' },
  ], // 防曬狀況
  sunProtectionHabits: [
    { title: '無', name: 'none', text: '' },
    { title: 'SPF15', name: 'spf15', text: '' },
    { title: 'SPF30', name: 'spf30', text: '' },
    { title: 'SPF30以上', name: 'spf30up', text: '' },
    { title: '備註', name: 'remark', text: '' },
  ], // 防曬習慣
  makeupRemoverType: [
    { title: '卸妝水', name: 'makeup-remover-water', text: '' },
    { title: '卸妝乳', name: 'makeup-remover-milk', text: '' },
    { title: '卸妝霜', name: 'makeup-remover-cream', text: '' },
    { title: '卸妝油', name: 'makeup-remover-oil', text: '' },
    { title: '卸妝巾', name: 'makeup-remover-wipes', text: '' },
    { title: '備註', name: 'remark', text: '' },
  ], // 卸妝產品類型
  skinCareProductsUsed: [
    { title: '化妝水', name: 'toner', text: '' },
    { title: '精華', name: 'serum', text: '' },
    { title: '乳液', name: 'lotion', text: '' },
    { title: '日霜', name: 'day-cream', text: '' },
    { title: '夜霜', name: 'night-cream', text: '' },
    { title: '眼霜', name: 'eye-cream', text: '' },
    { title: '保養油', name: 'maintenance-oil', text: '' },
    { title: '果酸', name: 'fruit-acid', text: '' },
    { title: '備註', name: 'remark', text: '' },
  ], // 使用的保養品
  recentMedicalTreatment: [{ title: '療程名稱', name: 'name', text: '' }, { title: '日期', name: 'date', text: '' }], // 近期醫美療程
  skinProblemYouWantToSolve: [
    { title: '開放粉刺', name: 'open-comedo', text: '' },
    { title: '閉鎖粉刺', name: 'closed-comedo', text: '' },
    { title: '痘痘', name: 'acne', text: '' },
    { title: '淡化痘疤', name: 'fade-acne-scars', text: '' },
    { title: '毛囊角化', name: 'follicular-hyperkeratosis', text: '' },
    { title: '毛孔粗大', name: 'enlarged-pores', text: '' },
    { title: '敏感泛紅', name: 'sensitive-redness', text: '' },
    { title: '乾燥', name: 'dryness', text: '' },
    { title: '坑洞', name: 'pitting', text: '' },
    { title: '膚色不均', name: 'uneven-skin-tone', text: '' },
    { title: '美白除斑', name: 'whitening-spot-removal', text: '' },
    { title: '肉芽', name: 'granulation', text: '' },
    { title: '黑眼圈', name: 'dark-circles', text: '' },
    { title: '淡化細紋', name: 'reduce-fine-lines', text: '' },
    { title: '緊緻拉提', name: 'firming-lifting', text: '' },
    { title: '備註', name: 'remark', text: '' },
  ], // 希望解決的肌膚問題
  // 美容產業
  vaccine: 0,
  // 按摩產業
  // 病史
  medicalHistory: [
    { title: '良好', name: 'good', text: '' },
    { title: '香港腳', name: 'athletesFoot', text: '' },
    { title: '心臟病', name: 'heartDisease', text: '' },
    { title: '惡性糖尿病', name: 'malignantDiabetes', text: '' },
    { title: '高血壓', name: 'hypertension', text: '' },
    { title: '長期咳嗽', name: 'chronicCough', text: '' },
    { title: '靜脈血栓炎(不明原因下肢疼痛）', name: 'venousThrombophlebitisUunexplainedLegPain)', text: '' },
    { title: '明顯靜脈曲張', name: 'pronouncedVaricoseVeins', text: '' },
    { title: '肌肉萎縮', name: 'muscleAtrophy', text: '' },
    { title: '扭傷（部位/日期）', name: 'sprain', text: '' },
    { title: '腫脹', name: 'swelling', text: '' },
    { title: '急性疼痛', name: 'acutePain', text: '' },
    { title: '脫臼', name: 'dislocation', text: '' },
    { title: '癌症/腫瘤', name: 'cancerTumor', text: '' },
    { title: '其他', name: 'other', text: '' },
  ],
  // 休閒運動種類
  typesOfRecreationalSports: [{ title: '有', name: 'hasSpecificSports', text: '' }, { title: '無特定運動種類', name: 'noSpecificSports', text: '' }],
  // 訓練或運動量
  trainingVolume: [
    { title: '每週運動5次以上', name: 'exerciseMoreThan5TimesPerWeek', text: '' },
    { title: '每週運動3~4次', name: 'exercise3To4TimesPerWeek', text: '' },
    { title: '每週運動1~2次偶爾', name: 'exercise1To2TimesPerWeekOccasionally', text: '' },
  ],
  // 希望改善部位
  desiredImprovementAreas: [
    { title: '肩', name: 'shoulder', text: '' },
    { title: '頸', name: 'neck', text: '' },
    { title: '腰', name: 'waist', text: '' },
    { title: '背', name: 'back', text: '' },
    { title: '大腿前側', name: 'frontThigh', text: '' },
    { title: '大腿後側', name: 'backThigh', text: '' },
    { title: '小腿', name: 'calf', text: '' },
    { title: '髖', name: 'hip', text: '' },
    { title: '臀', name: 'buttocks', text: '' },
    { title: '其他', name: 'other', text: '' },
  ],
  // 是否有任何種類按摩經驗
  massageExperience: [{ title: '是', name: 'yes', text: '' }, { title: '否', name: 'no', text: '' }],
  // 希望按摩力道
  massageIntensityPreference: [
    { title: '輕', name: 'light', text: '' },
    { title: '中等', name: 'medium', text: '' },
    { title: '稍重', name: 'moderate', text: '' },
    { title: '重', name: 'heavy', text: '' },
  ],
  // 按摩產業
}

export const afterOrder = [
  {
    title: '正常',
  },
  {
    title: '皮膚病',
  },
  {
    title: '指甲流血',
  },
  {
    title: '剃傷',
  },
  {
    title: '跳蚤',
    children: [
      {
        title: '少量',
        value: 1,
      },
      {
        title: '多量',
        value: 2,
      },
    ],
  },
  {
    title: '璧蝨',
    children: [
      {
        title: '少量',
        value: 1,
      },
      {
        title: '多量',
        value: 2,
      },
    ],
  },
  {
    title: '耳炎',
    children: [
      {
        title: '輕微',
        value: 1,
      },
      {
        title: '嚴重',
        value: 2,
      },
    ],
  },
  {
    title: '耳疥',
    children: [
      {
        title: '輕微',
        value: 1,
      },
      {
        title: '嚴重',
        value: 2,
      },
    ],
  },
  {
    title: '眼睛',
    children: [
      {
        title: '紅眼',
        value: 1,
      },
      {
        title: '分泌物',
        value: 2,
      },
      {
        title: '毛渣凝塊',
        value: 3,
      },
      {
        title: '闔眼',
        value: 4,
      },
    ],
  },
]

export const handle = [
  {
    title: '已上藥',
  },
  {
    title: '經醫師看診',
  },
]

// glow諮詢表
export const glowQuestions = {
  marriage: [
    {
      title: '已婚',
      name: 'married',
      text: '',
    },
    {
      title: '未婚',
      name: 'unmarried',
      text: '',
    },
  ],
  homeAddress: '',
  email: '',
  DM: [
    {
      title: '是',
      name: 'yes',
      text: '',
    },
    {
      title: '否',
      name: 'no',
      text: '',
    },
  ],
  job: [
    {
      title: '上班族',
      name: 'office-worker',
      text: '',
    },
    {
      title: '自由業',
      name: 'freelancer',
      text: '',
    },
    {
      title: '學生',
      name: 'student',
      text: '',
    },
    {
      title: '主婦',
      name: 'housewife',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  workingAddress: '',
  reasons: [
    {
      title: '親友介紹',
      name: 'introduction',
      text: '',
    },
    {
      title: 'Instagram/FB',
      name: 'social-media',
      text: '',
    },
    {
      title: '廣告',
      name: 'commercial',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  healthStatus: [
    {
      title: '良好',
      name: 'good',
      text: '',
    },
    {
      title: '普通',
      name: 'normal',
      text: '',
    },
    {
      title: '較差',
      name: 'poor',
      text: '',
    },
  ],
  disease: [
    {
      title: '貧血',
      name: 'anemia',
      text: '',
    },
    {
      title: '高血壓',
      name: 'hypertension',
      text: '',
    },
    {
      title: '癲癇',
      name: 'epilepsy',
      text: '',
    },
    {
      title: '心血管疾病',
      name: 'cardiovascular-disease',
      text: '',
    },
    {
      title: '糖尿病',
      name: 'diabetes',
      text: '',
    },
    {
      title: '皮膚疾病',
      name: 'skin-disease',
      text: '',
    },
    {
      title: '賀爾蒙失調',
      name: 'hormone-imbalance',
      text: '',
    },
    {
      title: '甲狀腺疾病',
      name: 'thyroid-disease',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  pressure: [
    {
      title: '低',
      name: 'low',
      text: '',
    },
    {
      title: '中',
      name: 'medium',
      text: '',
    },
    {
      title: '高',
      name: 'high',
      text: '',
    },
  ],
  allergy: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  medicine: [
    {
      title: '止痛藥',
      name: 'painkiller',
      text: '',
    },
    {
      title: '精神安定劑',
      name: 'tranquilizer',
      text: '',
    },
    {
      title: '避孕藥/荷爾蒙藥',
      name: 'contraceptive',
      text: '',
    },
    {
      title: '安眠藥',
      name: 'sleeping-pill',
      text: '',
    },
    {
      title: '抗生素',
      name: 'antibiotics',
      text: '',
    },
    {
      title: '甲狀腺藥物',
      name: 'thyroid-medicine',
      text: '',
    },
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '其他醫生開立之處方籤',
      name: 'other',
      text: '',
    },
  ],
  sleepQuality: [
    {
      title: '睡眠良好(6-8小時睡眠時間，無失眠)',
      name: 'good',
      text: '',
    },
    {
      title: '偶爾失眠(難以入眠、淺眠)',
      name: 'normal',
      text: '',
    },
    {
      title: '長期睡眠不足(少於5小時)',
      name: 'poor',
      text: '',
    },
  ],
  eatingHabits: [
    {
      title: '規律',
      name: 'regular',
      text: '',
    },
    {
      title: '不規律',
      name: 'irregular',
      text: '',
    },
    {
      title: '自煮',
      name: 'cook',
      text: '',
    },
    {
      title: '外食',
      name: 'eat-out',
      text: '',
    },
    {
      title: '便利商店',
      name: 'convenience-store',
      text: '',
    },
    {
      title: '零食',
      name: 'snack',
      text: '',
    },
    {
      title: '高蛋白飲食',
      name: 'high-protein',
      text: '',
    },
    {
      title: '低蛋白飲食',
      name: 'low-protein',
      text: '',
    },
    {
      title: '全素',
      name: 'vegan',
      text: '',
    },
    {
      title: '蛋奶素',
      name: 'ovo-lacto-vegetarian',
      text: '',
    },
    {
      title: '高糖高碳水飲食',
      name: 'high-carbohydrate',
      text: '',
    },
    {
      title: '油炸、辛辣飲食',
      name: 'fried-spicy',
      text: '',
    },
    {
      title: '速食、加工食品',
      name: 'instant-processed-food',
      text: '',
    },
    {
      title: '酒精攝取多',
      name: 'alcohol',
      text: '',
    },
    {
      title: '咖啡因攝取多',
      name: 'caffeine',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  purposes: [
    {
      title: '頭皮健康護理',
      name: 'scalp-care',
      text: '',
    },
    {
      title: '頭皮出油',
      name: 'oily-scalp',
      text: '',
    },
    {
      title: '頭皮屑',
      name: 'dandruff',
      text: '',
    },
    {
      title: '放鬆舒壓',
      name: 'relax-stress',
      text: '',
    },
    {
      title: '強健髮根',
      name: 'strong-hair-root',
      text: '',
    },
    {
      title: '改善落髮',
      name: 'hair-loss',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  scalpProblemRecently: [
    {
      title: '出油嚴重',
      name: 'oily',
      text: '',
    },
    {
      title: '乾燥',
      name: 'dry',
      text: '',
    },
    {
      title: '搔癢/敏感',
      name: 'itchy',
      text: '',
    },
    {
      title: '頭皮屑',
      name: 'dandruff',
      text: '',
    },
    {
      title: '落髮',
      name: 'hair-loss',
      text: '',
    },
    {
      title: '異味',
      name: 'smell',
      text: '',
    },
    {
      title: '紅腫',
      name: 'swelling',
      text: '',
    },
    {
      title: '痘痘',
      name: 'acne',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  hairProblem: [
    {
      title: '細軟髮',
      name: 'thin',
      text: '',
    },
    {
      title: '粗硬髮',
      name: 'coarse',
      text: '',
    },
    {
      title: '自然卷',
      name: 'curly',
      text: '',
    },
    {
      title: '長期染燙受損',
      name: 'damaged',
      text: '',
    },
    {
      title: '分岔',
      name: 'split',
      text: '',
    },
    {
      title: '毛躁',
      name: 'frizzy',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  hairWashFrequency: [
    {
      title: '每天',
      name: 'daily',
      text: '',
    },
    {
      title: '隔天',
      name: 'every-other-day',
      text: '',
    },
    {
      title: '兩天以上',
      name: 'more-than-two-days',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  oilyScalpProblem: [
    {
      title: '早上洗髮、晚上出油',
      name: 'morning-wash-night-oil',
      text: '',
    },
    {
      title: '1-2天出油',
      name: '1-2-days-oil',
      text: '',
    },
    {
      title: '三天以上出油',
      name: 'more-than-3-days-oil',
      text: '',
    },
    {
      title: '幾乎不出油',
      name: 'almost-no-oil',
      text: '',
    },
  ],
  dandruffProblem: [
    {
      title: '大量頭皮屑',
      name: 'large-amount-of-dandruff',
      text: '',
    },
    {
      title: '偶爾有頭皮屑',
      name: 'occasional-dandruff',
      text: '',
    },
    {
      title: '無',
      name: 'none',
      text: '',
    },
  ],
  scalpProblemPast: [
    {
      title: '產後落髮',
      name: 'hair-loss-after-childbirth',
      text: '',
    },
    {
      title: '斑禿/鬼剃頭',
      name: 'alopecia',
      text: '',
    },
    {
      title: '頭皮屑',
      name: 'dandruff',
      text: '',
    },
    {
      title: '出油',
      name: 'oily',
      text: '',
    },
    {
      title: '頭蘚',
      name: 'lichen',
      text: '',
    },
    {
      title: '植髮',
      name: 'hair-transplant',
      text: '',
    },
  ],
  hairCareProducts: [
    {
      title: '開架式',
      name: 'over-the-counter',
      text: '',
    },
    {
      title: '沙龍級',
      name: 'salon-grade',
      text: '',
    },
    {
      title: '草本',
      name: 'herbal',
      text: '',
    },
    {
      title: '保濕修護',
      name: 'moisturizing-repair',
      text: '',
    },
    {
      title: '控油去屑',
      name: 'oil-control-anti-dandruff',
      text: '',
    },
    {
      title: '無矽靈',
      name: 'silicone-free',
      text: '',
    },
    {
      title: '健髮產品(如落健、生髮水)',
      name: 'hair-growth',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  hasScalpCareService: [
    {
      title: '否',
      name: 'none',
      text: '',
    },
    {
      title: '是',
      name: 'yes',
      text: '',
      frequency: [
        {
          title: '每週',
          name: 'once-a-week',
          text: '',
        },
        {
          title: '每月',
          name: 'once-a-month',
          text: '',
        },
        {
          title: '不固定',
          name: 'irregular',
          text: '',
        },
      ],
    },
  ],
}

// 心傳諮詢表
export const shindenQuestions = {
  // 淨毛諮詢診療紀錄卡
  medicalHistory: [
    {
      title: '過敏性皮炎',
      name: 'allergic-dermatitis',
      text: '',
    },
    {
      title: '糖尿病',
      name: 'diabetes',
      text: '',
    },
    {
      title: '心髒疾病',
      name: 'heart-disease',
      text: '',
    },
    {
      title: '放射性治療',
      name: 'radiation-therapy',
      text: '',
    },
    {
      title: '高血壓',
      name: 'hypertension',
      text: '',
    },
    {
      title: '癲癇',
      name: 'epilepsy',
      text: '',
    },
    {
      title: '蟹足腫體質',
      name: 'keloid-constitution',
      text: '',
    },
    {
      title: '婦科疾病',
      name: 'gynecological-disease',
      text: '',
    },
    {
      title: '服用避孕藥',
      name: 'contraceptive-pill',
      text: '',
    },
    {
      title: '閉經',
      name: 'menopause',
      text: '',
    },
    {
      title: '光過敏',
      name: 'photosensitivity',
      text: '',
    },
    {
      title: '花粉過敏',
      name: 'pollen-allergy',
      text: '',
    },
    {
      title: '食物過敏',
      name: 'food-allergy',
      text: '',
    },
    {
      title: '金屬過敏',
      name: 'metal-allergy',
      text: '',
    },
  ],
  curingForHair: [
    {
      title: '無',
      name: 'no',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  medicationStatusForHair: [
    {
      title: '否',
      name: 'no',
      text: '',
    },
    {
      title: '是',
      name: 'yes',
      text: '',
    },
  ],
  healthStatusForHair: [
    {
      title: '良好',
      name: 'good',
      text: '',
    },
    {
      title: '普通',
      name: 'normal',
      text: '',
    },
    {
      title: '較差',
      name: 'poor',
      text: '',
    },
  ],
  menstrualPeriodStatusForHair: [
    {
      title: '規律',
      name: 'regular',
      text: '',
    },
    {
      title: '不順',
      name: 'irregular',
      text: '',
    },
    {
      title: '無',
      name: 'none',
      text: '',
    },
  ],
  skinProblemsForHair: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  majorSurgery: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  cosmeticSurgeryForHair: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  sunExposureForHair: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  hairRemovalSurgery: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  selfHairRemoval: [
    {
      title: '不處理',
      name: 'none',
      text: '',
    },
    {
      title: '處理',
      name: 'yes',
      text: '',
    },
  ],
  bodyParts: [
    {
      title: '腋下',
      name: 'armpit',
      text: '',
    },
    {
      title: '小腿',
      name: 'calf',
      text: '',
    },
    {
      title: '大腿',
      name: 'thigh',
      text: '',
    },
    {
      title: '小臂',
      name: 'forearm',
      text: '',
    },
    {
      title: '大臂',
      name: 'upper-arm',
      text: '',
    },
    {
      title: '手指',
      name: 'finger',
      text: '',
    },
    {
      title: '臉頰',
      name: 'cheek',
      text: '',
    },
    {
      title: '額頭',
      name: 'forehead',
      text: '',
    },
    {
      title: '胸毛',
      name: 'chest-hair',
      text: '',
    },
    {
      title: '後背',
      name: 'back',
      text: '',
    },
    {
      title: '乳暈',
      name: 'areola',
      text: '',
    },
    {
      title: '肚臍',
      name: 'navel',
      text: '',
    },
    {
      title: '脖頸',
      name: 'neck',
      text: '',
    },
    {
      title: '唇毛',
      name: 'lip-hair',
      text: '',
    },
    {
      title: '比基尼線/人魚線',
      name: 'mermaid-line',
      text: '',
    },
    {
      title: '腳趾',
      name: 'toe',
      text: '',
    },
    {
      title: '私處',
      name: 'genitals',
      text: '',
    },
    {
      title: '後庭',
      name: 'anus',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  reasonsForShinden: '',
  focus: [
    {
      title: '疼痛',
      name: 'pain',
      text: '',
    },
    {
      title: '效果',
      name: 'effect',
      text: '',
    },
    {
      title: '費用',
      name: 'cost',
      text: '',
    },
    {
      title: '施術時間',
      name: 'time',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  // 臉部諮詢紀錄卡
  healthStatusForFace: [
    {
      title: '良好',
      name: 'good',
      text: '',
    },
    {
      title: '普通',
      name: 'normal',
      text: '',
    },
    {
      title: '較差',
      name: 'poor',
      text: '',
    },
  ],
  menstrualPeriodStatusForFace: [
    {
      title: '規律',
      name: 'regular',
      text: '',
    },
    {
      title: '不順',
      name: 'irregular',
      text: '',
    },
  ],
  menstrualPainForFace: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  allergyForFace: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  curingForFace: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  medicationStatusForFace: [
    {
      title: '否',
      name: 'no',
      text: '',
    },
    {
      title: '是',
      name: 'yes',
      text: '',
    },
  ],
  contactLenses: [
    {
      title: '否',
      name: 'no',
      text: '',
    },
    {
      title: '是',
      name: 'yes',
      text: '',
    },
  ],
  sunExposureForFace: [
    {
      title: '否',
      name: 'no',
      text: '',
    },
    {
      title: '是',
      name: 'yes',
      text: '',
    },
  ],
  otherMedicalBeautyForFace: [
    {
      title: '否',
      name: 'no',
      text: '',
    },
    {
      title: '是',
      name: 'yes',
      text: '',
    },
  ],
  cosmeticSurgeryForFace: [
    {
      title: '無，臉部從未注射人工植入物(如玻尿酸、肉毒桿菌、隆鼻等人工填充物)',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  laserBeauty: [
    {
      title: '否',
      name: 'no',
      text: '',
    },
    {
      title: '是',
      name: 'yes',
      text: '',
    },
  ],
  skinProblemsForFace: [
    {
      title: '否',
      name: 'no',
      text: '',
    },
    {
      title: '是',
      name: 'yes',
      text: '',
    },
  ],
  skinCareProducts: [
    {
      title: '卸妝',
      name: 'makeup-remover',
      text: '',
    },
    {
      title: '清潔',
      name: 'cleanser',
      text: '',
    },
    {
      title: '化妝水',
      name: 'toner',
      text: '',
    },
    {
      title: '乳液',
      name: 'emulsion',
      text: '',
    },
    {
      title: '美容精華液',
      name: 'serum',
      text: '',
    },
    {
      title: '保養油',
      name: 'oil',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  beautyEquipment: [
    {
      title: '否',
      name: 'no',
      text: '',
    },
    {
      title: '是',
      name: 'yes',
      text: '',
    },
  ],
  skinProblemsSelectForFace: [
    {
      title: '痘痘粉刺',
      name: 'acne',
      text: '',
    },
    {
      title: '細紋',
      name: 'fine-lines',
      text: '',
    },
    {
      title: '斑',
      name: 'spots',
      text: '',
    },
    {
      title: '下垂',
      name: 'sagging',
      text: '',
    },
    {
      title: '毛細血管擴張',
      name: 'capillary-dilation',
      text: '',
    },
    {
      title: '痘痘肌',
      name: 'acne-prone-skin',
      text: '',
    },
    {
      title: '酒槽肌',
      name: 'rosacea',
      text: '',
    },
    {
      title: '黑頭',
      name: 'blackheads',
      text: '',
    },
    {
      title: '毛囊角化',
      name: 'follicular-keratosis',
      text: '',
    },
    {
      title: '紋路粗糙',
      name: 'rough-skin',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  // 日式純手技諮詢紀錄卡
  healthStatusForHand: [
    {
      title: '良好',
      name: 'good',
      text: '',
    },
    {
      title: '普通',
      name: 'normal',
      text: '',
    },
    {
      title: '較差',
      name: 'poor',
      text: '',
    },
  ],
  menstrualPeriodStatusForHand: [
    {
      title: '規律',
      name: 'regular',
      text: '',
    },
    {
      title: '不順',
      name: 'irregular',
      text: '',
    },
  ],
  menstrualPainForHand: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  pressureStatus: [
    {
      title: '高',
      name: 'high',
      text: '',
    },
    {
      title: '普通',
      name: 'normal',
      text: '',
    },
    {
      title: '低',
      name: 'low',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  constitution: [
    {
      title: '體寒',
      name: 'cold-body',
      text: '',
    },
    {
      title: '貧血',
      name: 'anemia',
      text: '',
    },
    {
      title: '肩頸僵硬',
      name: 'shoulder-neck-stiffness',
      text: '',
    },
    {
      title: '自律神經失調',
      name: 'autonomic-nervous-disorder',
      text: '',
    },
    {
      title: '失眠',
      name: 'insomnia',
      text: '',
    },
    {
      title: '高血壓',
      name: 'hypertension',
      text: '',
    },
    {
      title: '低血壓',
      name: 'low-blood-pressure',
      text: '',
    },
    {
      title: '便秘',
      name: 'constipation',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  curingForHand: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  allergyForHand: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  medicationStatusForHand: [
    {
      title: '否',
      name: 'no',
      text: '',
    },
    {
      title: '是',
      name: 'yes',
      text: '',
    },
  ],
  wackUpTime: '',
  sleepTime: '',
  sleepStatus: [
    {
      title: '馬上入眠',
      name: 'fall-asleep-immediately',
      text: '',
    },
    {
      title: '難以入眠',
      name: 'hard-to-fall-asleep',
      text: '',
    },
    {
      title: '神清氣爽',
      name: 'refreshed',
      text: '',
    },
    {
      title: '疲倦',
      name: 'tired',
      text: '',
    },
  ],
  holidays: '',
  activities: [
    {
      title: '慢活',
      name: 'slow-life',
      text: '',
    },
    {
      title: '外出',
      name: 'outdoor',
      text: '',
    },
    {
      title: '社交',
      name: 'socializing',
      text: '',
    },
    {
      title: '運動',
      name: 'exercise',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  preparingForPregnancy: [
    {
      title: '無',
      name: 'none',
      text: '',
    },
    {
      title: '有',
      name: 'yes',
      text: '',
    },
  ],
  height: '',
  weight: '',
  eatingStatus: [
    {
      title: '規律',
      name: 'regular',
      text: '',
    },
    {
      title: '不規律',
      name: 'irregular',
      text: '',
    },
  ],
  eatingHabits: [
    {
      title: '內食',
      name: 'home-cooked',
      text: '',
    },
    {
      title: '外食',
      name: 'eat-out',
      text: '',
    },
    {
      title: '便利商店',
      name: 'convenience-store',
      text: '',
    },
    {
      title: '零食',
      name: 'snack',
      text: '',
    },
  ],
  hobby: [
    {
      title: '抽菸',
      name: 'smoking',
      text: '',
    },
    {
      title: '飲酒',
      name: 'drinking',
      text: '',
    },
    {
      title: '咖啡',
      name: 'caffeine',
      text: '',
    },
    {
      title: '油炸',
      name: 'fried-food',
      text: '',
    },
    {
      title: '鹹辣',
      name: 'spicy',
      text: '',
    },
    {
      title: '重口味',
      name: 'heavy-flavor',
      text: '',
    },
  ],
  healthProblemsForHand: [
    {
      title: '肩頸僵硬',
      name: 'shoulder-neck-stiffness',
      text: '',
    },
    {
      title: '胃痛',
      name: 'stomachache',
      text: '',
    },
    {
      title: '背部酸痛',
      name: 'back-pain',
      text: '',
    },
    {
      title: '厚實',
      name: 'thick',
      text: '',
    },
    {
      title: '手臂無力',
      name: 'arm-weakness',
      text: '',
    },
    {
      title: '內臟不適',
      name: 'internal-discomfort',
      text: '',
    },
    {
      title: '便秘',
      name: 'constipation',
      text: '',
    },
    {
      title: '頻尿',
      name: 'frequent-urination',
      text: '',
    },
    {
      title: '腰痛',
      name: 'lower-back-pain',
      text: '',
    },
    {
      title: '關節痛',
      name: 'joint-pain',
      text: '',
    },
    {
      title: '偏頭痛',
      name: 'migraine',
      text: '',
    },
    {
      title: '橘皮組織',
      name: 'cellulite',
      text: '',
    },
    {
      title: '體型',
      name: 'body-shape',
      text: '',
    },
    {
      title: '體重',
      name: 'weight',
      text: '',
    },
    {
      title: '體寒',
      name: 'cold-body',
      text: '',
    },
    {
      title: '水腫',
      name: 'swelling',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  skinProblemsForHand: [
    {
      title: '痘痘粉刺',
      name: 'acne',
      text: '',
    },
    {
      title: '細紋',
      name: 'fine-lines',
      text: '',
    },
    {
      title: '斑',
      name: 'spots',
      text: '',
    },
    {
      title: '下垂',
      name: 'sagging',
      text: '',
    },
    {
      title: '毛細血管擴張',
      name: 'capillary-dilation',
      text: '',
    },
    {
      title: '痘痘肌',
      name: 'acne-prone-skin',
      text: '',
    },
    {
      title: '酒槽肌',
      name: 'rosacea',
      text: '',
    },
    {
      title: '黑頭',
      name: 'blackheads',
      text: '',
    },
    {
      title: '毛囊角化',
      name: 'follicular-keratosis',
      text: '',
    },
    {
      title: '紋路粗糙',
      name: 'rough-skin',
      text: '',
    },
    {
      title: '其他',
      name: 'other',
      text: '',
    },
  ],
  otherMedicalBeautyForHand: [
    {
      title: '否',
      name: 'no',
      text: '',
    },
    {
      title: '是',
      name: 'yes',
      text: '',
    },
  ],
  beautyExpenses: '',
}

export const currentQuestionList = (alias) => {
  const questionMapping = {
    'glow-headspa': glowQuestions,
    shinden: shindenQuestions,
  }

  return questionMapping[alias] || defaultQuestions
}
